import React from 'react'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
const modules = {
    toolbar: [
        [{ 'header': '1' }, { 'header': '2' },],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ['bold', 'italic', 'underline',],
        [{ 'align': [] }],
        ['link'],
    ],
};
const TextEditor = ({value, onChange, readOnly}) => {
    return (
        <ReactQuill
            theme="snow"
            value={value}
            onChange={onChange}
            modules={modules}
            readOnly={readOnly}
            placeholder='Notes'
            style={{ background: readOnly ? '#f9f9f9' : 'white' }}
        />
    )
};
// Custom styles to apply scroll within content area
const styles = `
    .ql-editor {
        max-height: 200px;
        overflow-y: auto;
    }
`;

// Injecting the styles into the head of the document
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default TextEditor
